import React from "react";
import "./LpFooter.css";
const LpFooter = () => {
  return (
    <div className="lpFooter-container">
      <b>© 2008 - 2024 GoodWay Attestation. All Rights Reserved.</b>

      <div className="lpFooter-links">
        <ul>
          <li>attestation of degree certificate for uae</li>
          <li>mea certificate attestation</li>
          <li>mofa attestation in india</li>
          <li>marriage attestation in india</li>
          <li>document attestation in bangalore</li>
          <li>state home department attestation</li>
          <li>embassy verification certificate for switzerland</li>
          <li>embassy attestation services near me</li>
          <li>embassy attestation services</li>
          <li>attestation for degree certificate</li>
          <li>education certificate attestation in india</li>
          <li>attestation centre near me</li>
          <li>birth certificate attestation near me</li>
          <li>attestation service</li>
          <li>certificate attestation for uae</li>
          <li>certificate attestation india</li>
          <li>apostille service in bangalore</li>
          <li>hrd attestation office in bangalore</li>
          <li>mea attestation</li>
          <li>marriage certificate attestation in india</li>
          <li>apostille attestation services</li>
          <li>certificate attestation services near me</li>
          <li>mea attestation near me</li>
          <li>certificate attestation dubai</li>
          <li>apostille from mea</li>
          <li>degree attestation near me</li>
          <li>embassy verification certificate for switzerland from india</li>
          <li>mea attestation cost</li>
          <li>uae embassy attestation</li>
          <li>attestation services in bangalore</li>
          <li>attestation near me</li>
          <li>certificate attestation in bangalore</li>
          <li>uae attestation services in bangalore</li>
          <li>uae embassy in bangalore</li>
          <li>mea attestation in bangalore</li>
          <li>uae attestation in bangalore</li>
          <li>attestation services near me</li>
          <li>hrd attestation in bangalore</li>
          <li>degree attestation for uae</li>
          <li>certificate attestation</li>
          <li>certificate attestation near me</li>
          <li>degree certificate attestation cost in india</li>
          <li>document attestation near me</li>
          <li>hrd attestation bangalore office address</li>
          <li>uae embassy attestation bengaluru</li>
          <li>degree certificate attestation in bangalore</li>
          <li>hrd attestation bangalore</li>
          <li>marriage certificate attestation</li>
          <li>qatar embassy in india</li>
          <li>mofa attestation bangalore</li>
          <li>mofa attestation in bangalore</li>
          <li>uae embassy bangalore</li>
          <li>attestation in bangalore</li>
          <li>documents attestation near me</li>
          <li>uae attestation near me</li>
          <li>degree certificate attestation for uae price</li>
          <li>mofa attestation near me</li>
          <li>uae attestation bangalore</li>
          <li>certificate attestation in mangalore</li>
          <li>degree certificate attestation</li>
          <li>police clearance certificate bangalore</li>
          <li>attestation of degree certificate</li>
          <li>degree certificate attestation for uae price in india</li>
          <li>uae embassy attestation bangalore</li>
          <li>hrd attestation karnataka</li>
          <li>mea attestation fees</li>
          <li>document attestation bangalore</li>
          <li>marriage certificate attestation in bangalore</li>
          <li>uae embassy attestation in bangalore</li>
          <li>birth certificate attestation</li>
          <li>degree certificate attestation for uae in india</li>
          <li>kuwait embassy attestation</li>
          <li>certificate attestation services in bangalore</li>
          <li>degree certificate attestation for uae in bangalore</li>
          <li>embassy attestation in bangalore</li>
          <li>hrd department karnataka</li>
          <li>indian embassy bahrain attestation</li>
          <li>power of attorney indian embassy bahrain</li>
          <li>Bahrain Embassy Attestation</li>
          <li>Marriage Certificate Bahrain</li>
          <li>attestation for bahrain</li>
          <li>bahrain embassy attestation fees</li>
          <li>Bahrain Embassy Attestation Services</li>
          <li>marriage certificate attestation for bahrain</li>
          <li>qatar attestation services near me</li>
          <li>attestation for qatar</li>
          <li>qatar certificate attestation</li>
          <li>qatar attestation services in bangalore</li>
          <li>mofa attestation qatar</li>
          <li>qatar mofa attestation</li>
          <li>qatar embassy attestation in bangalore</li>
          <li>qatar embassy attestation</li>
          <li>qatar attestation in bangalore</li>
          <li>educational certificate attestation for qatar</li>
          <li>certificate attestation for qatar in india</li>
          <li>saudi culture attestation</li>
          <li>diploma certificate attestation for saudi</li>
          <li>educational certificate attestation for saudi arabia</li>
          <li>certificate attestation for saudi arabia</li>
          <li>engineering certificate attestation for saudi</li>
          <li>document attestation for saudi arabia</li>
          <li>saudi embassy attestation</li>
          <li>saudi attestation</li>
          <li>degree attestation in saudi arabia</li>
          <li>marriage certificate attestation for saudi arabia</li>
          <li>document attestation for saudi arabia in india</li>
          <li>degree apostille for saudi arabia</li>
          <li>saudi embassy attestation fees</li>
          <li>saudi attestation cost</li>
          <li>certificate attestation saudi arabia</li>
          <li>saudi arabia certificate attestation</li>
          <li>degree certificate attestation for saudi arabia</li>
          <li>degree attestation from saudi embassy in india</li>
          <li>saudi embassy degree attestation</li>
          <li>saudi embassy attestation fees in india</li>
          <li>degree attestation for saudi arabia</li>
          <li>marriage certificate attestation for saudi</li>
          <li>hrd attestation for saudi</li>
          <li>marriage certificate attestation in india for saudi arabia</li>
          <li>attestation for saudi arabia</li>
          <li>saudi embassy document attestation</li>
          <li>attestation for uae in india</li>
          <li>degree certificate attestation in bangalore for uae</li>
          <li>education certificate attestation for uae</li>
          <li>uae attestation in india</li>
          <li>dubai certificate attestation</li>
          <li>degree attestation for uae in bangalore</li>
          <li>uae marriage certificate attestation</li>
          <li>certificate attestation for uae in bangalore</li>
          <li>uae certificate attestation near me</li>
          <li>uae certificate attestation process</li>
          <li>uae attestation services near me</li>
          <li>uae education certificate attestation</li>
          <li>birth certificate attestation for uae visa</li>
          <li>degree certificate attestation for uae</li>
          <li>marriage certificate attestation for uae visa</li>
          <li>uae mofa attestation</li>
          <li>certificate attestation for uae near me</li>
          <li>uae mofa attestation near me</li>
          <li>uae certificate attestation in bangalore</li>
          <li>uae embassy attestation fees in india</li>
          <li>uae attestation</li>
          <li>uae embassy attestation fees</li>
          <li>uae certificate attestation</li>
          <li>uae attestation cost</li>
          <li>dubai attestation</li>
          <li>mofa attestation dubai</li>
          <li>document attestation for uae </li>
        </ul>
      </div>
      <p>
        Disclaimer: Goodway Attestation is an independent private document
        attestation and legalization service provider in Bangalore, Karnataka.
        We are not a governament authority, embassy, consulate or governament
        department and we do not represent any governament unless expressly
        stated and supposed by official authorization, Our services are limited
        to documents processing, attestation, legalization and related
        assistance. Governament requirements, fees, processing times and
        outcomes may vary depending on the document type and the concerned
        authority. We do not guarnatee visa approval, immigration approval,
        employment, admission or any governament decision.
      </p>
    </div>
  );
};

export default LpFooter;
